export const LARGE_SCREEN = 979;
